import { ASSIGN_ENTITY_FROM_GROUP_SUCCESS } from 'modules/groups/actionTypes';
import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Record<string, import('modules/questionModels/types').QuestionModel>} ByIdReducer */

/** @type {ByIdReducer} */
const initialState = {};

const updateQuestion = (state, { payload }) => ({
  ...state,
  [payload.id]: payload,
});

/**
 * @param {ByIdReducer} state
 * @returns {ByIdReducer}
 */
const updateFromAssign = (state, { payload: questionModel, meta = {} }) => {
  if (meta.source === 'questionFormModels') {
    return updateOne(state, questionModel);
  }
  return state;
};

/**
 * @param {ByIdReducer} state
 * @param {import("modules/questionModels/types").FetchQuestionModelsSuccessAction} action
 * @returns {ByIdReducer}
 */
const updateOne = (state, question) => {
  const { assignments, breakdownAssignments, ...prevStateEntity } = state[question.id] ?? {};
  return {
    ...state,
    [question.id]: {
      ...prevStateEntity,
      ...question,
    },
  };
};

/**
 * @param {ByIdReducer} state
 * @param {import("modules/selfServices/types/actions").FetchQuestionModelsSuccessAction} action
 * @returns {ByIdReducer}
 */
const update = (state, { payload }) =>
  payload.content?.reduce((newState, question) => updateOne(newState, question), state) ?? state;

/** @returns {ByIdReducer} */
const clearQuestionModel = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_QUESTION_MODELS_SUCCESS]: update,
  [types.FETCH_QUESTION_MODEL_SUCCESS]: updateQuestion,
  [types.UPDATE_QUESTION_MODEL_SUCCESS]: updateQuestion,
  [types.CLEAR_QUESTION_MODEL_STATISTIC]: clearQuestionModel,
  [types.FETCH_DEFAULT_QUESTION_MODEL_SUCCESS]: updateQuestion,
  [ASSIGN_ENTITY_FROM_GROUP_SUCCESS]: updateFromAssign,
});
